import React from 'react';
import { connect } from 'react-redux';
import ResultIndex from './resultIndex/resultIndex';
import GuideSectionsIndex from './guideSectionsIndex/guideSectionsIndex';
import ContentResult from './contentResult/contentResult';
import LoadingCard from '../../shared/loadingCard/loadingCard';
import NoResultsCard from './resultIndex/noResultsCard/noResultsCard';

class ResultDisplay extends React.Component {
    render() {
        const { loading, filteredResults, assessment } = this.props;
        let display;

        // TODO: Clean up this logic block
        if (assessment.resultsConfig && assessment.resultsConfig.displayType === 'content') {
            // Content result display
            display = <ContentResult />;

        } else if (assessment.resultsConfig && assessment.resultsConfig.displayType === 'guide-sections') {
            // Guide section display
            display = <GuideSectionsIndex />;

        } else if (filteredResults && filteredResults.length === 0) {
            // Result card display
            let copy = 'Sorry, we didn’t find any matching results.';
            if (assessment && assessment.resultsConfig) {
                if (assessment.resultsConfig.noResultsCopy) {
                    copy = assessment.resultsConfig.noResultsCopy;
                }
            }

            display = <NoResultsCard copy={copy} />;
        } else if (loading) {
            let loadingCopy = 'Finding your results...';

            if (assessment && assessment.loadingConfig) {
                loadingCopy = assessment.loadingConfig.copy;
            }

            display = <LoadingCard copy={loadingCopy} />;
        } else {
            display = <ResultIndex />;
        }

        return <div className="content-container border">{display}</div>;
    }
}

const mapStateToProps = state => {
    return {
        assessment: state.app.assessment,
        filteredResults: state.session.filteredResults,
        loading: state.ui.resultsLoading
    };
};

export default connect(mapStateToProps, null)(ResultDisplay);
